import { render, staticRenderFns } from "./estateGradual.vue?vue&type=template&id=0071d9a4&scoped=true"
import script from "./estateGradual.vue?vue&type=script&lang=js"
export * from "./estateGradual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0071d9a4",
  null
  
)

export default component.exports